import React from "react";

import { composeQA } from "@multiweb/reactUtils";
import { Option } from "@multiweb/types/react";
import { Select } from "../Select";
import { SelectBody } from "../SelectBody";
import { SelectItem } from "../SelectItem";
import { SelectTextButton } from "../SelectTextButton";

export type TextButtonSelectProps<T extends string> = {
    /** Hodnota vybrané položky */
    value: T | undefined;
    /** Položky pro výběr zobrazené v seznamu */
    options: ReadonlyArray<Option<T>>;
    /** Popisek pro rozevírací textové tlačítko */
    title?: string;
    /** Funkce volaná po výběru hodnoty */
    onChange: (value?: T) => void;
    /** Text rozevíracího tlačítka před vybráním hodnoty */
    defaultText?: string;
};

/** Komponenta rozevíracího seznamu otevíraného textovým tlačítkem */
export const TextButtonSelect = <T extends string>({
    value,
    options,
    title,
    defaultText,
    onChange,
}: TextButtonSelectProps<T>) => (
        <Select<T>
            {...{ value, options, onChange }}
            selectedOptionContent={({ text, opened, setOpened }) => (
                <SelectTextButton
                    onClick={() => setOpened(!opened)}
                    text={text || defaultText}
                    {...{ title }}
                    qa={composeQA("select-text-button")}
                />
            )}
            optionsContent={({ opened, value, onSelect, assignRef }) => (opened && (
                <SelectBody>
                    {options.map((option, index) => (
                        <SelectItem
                            key={option.value}
                            isSelected={option.value === value}
                            text={option.text}
                            qa={option.value}
                            ref={assignRef(index, options.length)}
                            onSelect={() => onSelect(option.value)}
                        />
                    ))}
                </SelectBody>
            ))}
        />
    );
